import { API } from "aws-amplify";

const apiName = "api-global-cdm";
const baseUrl = "/mycdm"

/**
 * `getMyDashboard` is a function that takes in a structureId id and a callback function. 
 * It then calls the API to get the `mycdm` and passes the `mycdm` to the callback function
 * @param id - The ID of the dashboard you want to get.
 * @param callBack - a function that will be called with the results of the API call.
 */
export function getMyDashboard(id, callBack) {
    API.get(apiName, `${baseUrl}/${id}`).then(
        mycdm => {
            callBack(mycdm)
        }).catch(err => { console.log(err.message) });
}

/**
 * It gets the team with the specified id.
 * @param id - The ID of the team you want to get.
 * @param callBack - a function that will be called with the team object as a parameter.
 */
export function getMyTeam(id, callBack) {
    API.get(apiName, `${baseUrl}/team/${id}`).then(
        team => {
            callBack(team);
        }).catch(err => { console.log(err.message) });
}

/**
 * `changeUserState` changes the state of a user in the team
 * @param id - The ID of the team you want to change the state of.
 * @param user - The user object that will be updated.
 * @param callBack - a function that will be called when the API call is complete.
 */
export function changeUserState(id, user, callBack) {
    const _user = JSON.parse(JSON.stringify(user));
    _user.Enabled = !user.Enabled;
    API.put(apiName, `${baseUrl}/team/state/${id}`, { body: _user }).then(
        rUser => {
            getMyTeam(id, callBack);
        }).catch(err => { console.log(err.message) });
}

/**
 * This function is used to save or create a user.
 * @param id - The ID of the structure to update.
 * @param user - The user object that will be saved or created.
 * @param callBack - A function that will be called with the result of the API call.
 */
export function saveOrCreateUser(id, user, callBack) {
    const _user = JSON.parse(JSON.stringify(user));
    if (user.sub) {
        // Mise à jour d'un utilisateur existant
        API.put(apiName, `${baseUrl}/team/${id}`, { body: _user })
            .then(rUser => {
                getMyTeam(id, callBack);
            })
            .catch(err => {
                const error = {
                    status: err.response.status || 500,
                    message: err.response.data?.error || 'Une erreur est survenue'
                };
                callBack(null, error);
            });
    } else {
        API.post(apiName, `${baseUrl}/team/${id}`, { body: _user })
            .then(rUser => {
                if (rUser.sub) {
                    getMyTeam(id, callBack);
                } else {
                    callBack(null, false, rUser);
                }
            })
            .catch(err => {
                const error = {
                    status: err.response.status || 500,
                    message: err.response.data?.error || 'Une erreur est survenue'
                };
                callBack(null, error);
            });
    }
}

/**
 * Update the profile of the current user
 * @param id - The ID of the structure to update.
 * @param user - The user object that will be updated.
 * @param callBack - A function that will be called when the request is completed.
 */
export function updateMyProfile(id, user, callBack) {
    const _user = JSON.parse(JSON.stringify(user));
    if (user.sub) {
        API.put(apiName, `${baseUrl}/team/${id}`, { body: _user }).then(
            () => {
                callBack();
            }).catch(err => { callBack(err); });
    }
}

/**
 * It gets all the allowed structures if more than 25 from the API
 * @param callBack - a function that will be called with the structures as a parameter.
 */
export function getAllStructures(callBack) {
    API.get(apiName, `${baseUrl}/structures`).then(
        structures => {
            callBack(structures);
        }).catch(err => { console.log(err.message) });
}

export const downloadCgu = async (key) => {
    const cgu = await API.get(apiName, `${baseUrl}/cgu/${key}`).then(
        cgu => { return cgu.headers.Location }).catch(err => { console.log(err) });
    return cgu;
}

export const updateCgu = async (key, structureId) => {
    const cgu = await API.put(apiName, `${baseUrl}/cgu/${key}`, { body: structureId }).then(
        cgu => { return cgu }).catch(err => { console.log(err) });
    return cgu;
}